const DeleteConfirmation = ({ setIsOverlayOpen, onConfirm }) => {
    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <button className="close-popup" onClick={() => setIsOverlayOpen(false)}>
                    <i className="fas fa-times"></i>
                </button>
                <h2 className="text-2xl">Are you sure?</h2>
                <p className="popup-msg">Please confirm that you will delete this item. This process cannot be undone.</p>
                <div className="popup-delete-buttons">
                    <button className="cancel-delete" onClick={() => setIsOverlayOpen(false)}>
                        Cancel
                    </button>
                    <button className="confirm-delete" onClick={onConfirm}>
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DeleteConfirmation;